import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Success.css';

// ADR-027 (Decision) + Amendment 1 §A1.4(c): the booking-return context rides
// the URL across the external Stripe redirect. The backend (001-F-BE,
// stripeController.js) conditionally parameterizes success_url with the
// validated { returnTo, sessionType, date, suite, time } shape, so /success
// reconstructs the context purely from its own query string — NOT from
// browser storage. This kills the R-020 paid-but-stranded vector (the legacy
// browser-storage carrier could not reliably survive the external-domain
// redirect). The URL carrier is self-cleaning by construction, so the prior
// 30-minute TTL staleness hack is obsolete and removed.
const readBookingReturnContext = (search) => {
  try {
    const params = new URLSearchParams(search);
    const returnTo = params.get('returnTo');
    const sessionType = params.get('sessionType');
    const date = params.get('date');
    const suite = params.get('suite');
    const time = params.get('time');
    // Mirror the backend's binding contract: returnTo must be the exact
    // constant; sessionType + date are required. Anything else => no context
    // (regression-safe /member fallback).
    if (returnTo !== '/book-session') return null;
    if (!sessionType || !date) return null;
    return { returnTo, sessionType, date, suite: suite || '', time: time || '' };
  } catch (err) {
    return null;
  }
};

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      const ctx = readBookingReturnContext(location.search);
      if (ctx) {
        const params = new URLSearchParams();
        params.set('sessionType', ctx.sessionType);
        params.set('date', ctx.date);
        if (ctx.suite) params.set('suite', ctx.suite);
        if (ctx.time) params.set('time', ctx.time);
        params.set('autoSubmit', '1');
        navigate(`/book-session?${params.toString()}`, { replace: true });
        return;
      }
      navigate('/member');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, location.search]);

  return (
    <div className="success-container">
      <h1>Thank you for your purchase!</h1>
    </div>
  );
};

export default Success;
